import React, {Component} from 'react';
import Layout from '../../components/Layout';
import SEO from '../../components/seo';
import { Link, withPrefix } from 'gatsby';

export default class IndexPage extends Component {
  render() {
    const {catLink: {path, name}, data: {text, img}, title, title_short} = this.props.pageContext;
    const pageTitle = `${title_short} | Монтаж и эксплуатация`;
    return <Layout>
        <SEO title={pageTitle} />
        <div id="main" className='catalog'>
          <div className="inner">
            <div className='parent-category'>
              <Link to={path}>&larr; {name}</Link>
            </div>
            <h1>Монтаж и эксплуатация</h1>
            <h2>{title}</h2>
            <section className='manual'>
              <div className="row">
                <div className="col-12">
                  <div className="image">
                    <img src={withPrefix(img[0])} alt={title_short} />
                  </div>
                </div>
                <div className="col-8">
                  <div dangerouslySetInnerHTML={{ __html: text }}/>
                </div>
              </div>
            </section>
          </div>
        </div>
      </Layout>;
  }
}
